/*
 * Title: Button/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Global Button use where we need & passing props for icons,text and action
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import twitter_new from "@assets/twitter_new.png";
import instagram_logo from "@assets/instagram_white.png";
import youtube_red_logo from "@assets/youtube.png";
import letter_logo from "@assets/logo_letter.png";
import tiktok_logo from "@assets/tiktok_logo.png";
import twitch_white from "@assets/twitch_white.png";
import shopify_logo from "@assets/shopify_logo.png";
import discord_logo from "@assets/discord_logo.png";
import spotify_logo from "@assets/signals.png";
import typeform from "@assets/typeform.png";
type Props = {
  icon: string;
};

const Icon_White: React.FC<Props> = (props) => {
  const { icon } = props;
  return (
    <>
      {
        /* twitter icon */
        (icon === "Twitter" || icon === "twitter") && (
          <img src={twitter_new} alt="twitter" className="h-[14px] w-[17px]" />
        )
      }
      {
        /* instagram icon */
        (icon === "Instagram" || icon === "instagram") && (
          <img
            src={instagram_logo}
            alt="Instagram"
            className="h-[18px] w-[18px]"
          />
        )
      }
      {
        /* Youtube icon */
        (icon === "Youtube" || icon === "youtube") && (
          <img
            src={youtube_red_logo}
            alt="Youtube"
            className="h-[13px] w-[18px]"
          />
        )
      }
      {
        /* Tiktok icon */
        (icon === "Tiktok" || icon === "tiktok") && (
          <img
            src={tiktok_logo}
            alt="Tiktok"
            className="object-contain h-[18px] w-[18px]"
          />
        )
      }
      {
        /* Twitch icon */
        (icon === "Twitch" || icon === "twitch") && (
          <img
            src={twitch_white}
            alt="Twitch"
            className="object-contain h-[18px] w-[18px]"
          />
        )
      }
      {
        /* Twitch icon */
        (icon === "Partnerships" || icon === "partnerships") && (
          <img
            src={letter_logo}
            alt="Partnerships"
            className="object-contain h-[14px] w-[17px]"
          />
        )
      }
      {
        /* Shopify icon */
        (icon === "Shopify" || icon === "shopify") && (
          <img
            src={shopify_logo}
            alt="Shopify"
            className="object-contain h-[18px] w-[18px]"
          />
        )
      }
      {
        /* Discord icon */
        (icon === "Discord" || icon === "discord") && (
          <img
            src={discord_logo}
            alt="Discord"
            className="object-contain  h-[18px] w-[18px]"
          />
        )
      }
      {
        /* Spotify icon */
        (icon === "Spotify" || icon === "spotify") && (
          <img
            src={spotify_logo}
            alt="Spotify"
            className="object-contain  h-[18px] w-[18px]"
          />
        )
      }
      {
        /* Typeform icon */
        (icon === "Typeform" || icon === "typeform") && (
          <img
            src={typeform}
            alt="Typeform"
            className="object-contain  h-[18px] w-[18px]"
          />
        )
      }
    </>
  );
};
export default Icon_White;
